export default __webpack_public_path__ + "images/162715856843d638b6b8f56bac111aaa-international_affairs_small.webp";